module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "maintenance-tab p-3"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("DEBUG: items=" + _vm._s(_vm.items ? _vm.items.length : 'null') + ", loading=" + _vm._s(_vm.loading))]), _vm._v(" "), (_vm.selectedVehicleId && (_vm.itemBrief || []).length > 0) ? _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-card', {
    staticClass: "border-0 shadow-sm glass-card mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "p-3 bg-primary border-bottom d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('md-icon', {
    staticClass: "text-white mr-2"
  }, [_vm._v("analytics")]), _vm._v(" "), _c('h5', {
    staticClass: "text-white font-weight-bold mb-0"
  }, [_vm._v("Consumed Parts Summary (Total Brief)")])], 1), _vm._v(" "), _c('b-badge', {
    staticClass: "px-3 py-1",
    attrs: {
      "pill": "",
      "variant": "light"
    }
  }, [_vm._v("Deep Item Brief")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-0 position-relative"
  }, [(_vm.briefLoading) ? _c('div', {
    staticClass: "brief-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    staticClass: "brief-table mb-0",
    attrs: {
      "small": "",
      "hover": "",
      "striped": "",
      "responsive": "",
      "items": _vm.itemBrief,
      "fields": _vm.briefFields
    }
  }, [
    [_c('span', {
      staticClass: "font-weight-bold text-primary"
    }, [_vm._v("₹ " + _vm._s(Number(_vm.scope.value).toLocaleString('en-IN')))])], _vm._v(" "), [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v("₹" + _vm._s(_vm.scope.item.minRate) + " - ₹" + _vm._s(_vm.scope.item.maxRate))])]
  ], 2)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "border-0 shadow-sm overflow-hidden glass-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "p-4 bg-white border-bottom d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h4', {
    staticClass: "font-weight-bold mb-1 text-dark"
  }, [_vm._v("Maintenance History")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted small mb-0"
  }, [_vm._v("Expand rows to view part-level itemized breakdown")])]), _vm._v(" "), _c('b-button', {
    staticClass: "btn-book px-4 shadow-sm",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.$emit('book-service')
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("add")]), _vm._v(" BOOK SERVICE\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table', {
    staticClass: "maintenance-table mb-0",
    attrs: {
      "items": _vm.items,
      "fields": _vm.historyFields,
      "hover": "",
      "responsive": "",
      "busy": _vm.loading,
      "head-variant": "light"
    },
    on: {
      "row-clicked": _vm.toggleDetails
    },
    scopedSlots: _vm._u([{
      key: "cell(ticketId)",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('md-icon', {
          staticClass: "mr-2 text-muted",
          attrs: {
            "size": "16"
          }
        }, [_vm._v(_vm._s(scope && scope.item && scope.item._showDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_right'))]), _vm._v(" "), _c('span', {
          staticClass: "text-dark font-weight-bold"
        }, [_vm._v(_vm._s(scope ? scope.value : ''))])], 1)]
      }
    }, {
      key: "cell(vehicleNo)",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "font-weight-bold text-primary vehicle-link",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('select-vehicle', scope && scope.item ? scope.item.vehicleNo : '')
            }
          }
        }, [_vm._v("\n            " + _vm._s(scope ? scope.value : '') + "\n          ")])]
      }
    }, {
      key: "cell(serviceDate)",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.formatDisplayDate(scope ? scope.value : null)) + "\n        ")]
      }
    }, {
      key: "cell(status)",
      fn: function(scope) {
        return [_c('b-badge', {
          staticClass: "status-pill",
          class: _vm.getStatusClass(scope ? scope.value : ''),
          attrs: {
            "pill": ""
          }
        }, [_vm._v("\n            " + _vm._s((scope ? scope.value : '') || 'Pending') + "\n          ")])]
      }
    }, {
      key: "cell(estimatedCost)",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "font-weight-bold text-dark"
        }, [_vm._v("₹ " + _vm._s(Number((scope ? scope.value : 0) || 0).toLocaleString('en-IN')))])]
      }
    }, {
      key: "row-details",
      fn: function(scope) {
        return [_c('b-card', {
          staticClass: "m-2 item-details-card border-0 shadow-sm bg-light"
        }, [_c('h6', {
          staticClass: "text-primary font-weight-bold border-bottom pb-2 mb-3"
        }, [_c('md-icon', {
          staticClass: "mr-1",
          attrs: {
            "size": "18"
          }
        }, [_vm._v("list_alt")]), _vm._v(" Itemized Breakdown for " + _vm._s(scope && scope.item ? scope.item.ticketId : '') + "\n            ")], 1), _vm._v(" "), _c('b-table', {
          staticClass: "item-details-table mb-0",
          attrs: {
            "striped": "",
            "hover": "",
            "small": "",
            "head-variant": "dark",
            "items": (scope && scope.item && scope.item.items) || [],
            "fields": _vm.itemizedFields
          },
          scopedSlots: _vm._u([{
            key: "cell(ratePerUnit)",
            fn: function(innerRow) {
              return [_vm._v("\n                ₹ " + _vm._s(Number(String(innerRow.value).replace(/,/g, '')).toLocaleString('en-IN')) + "\n              ")]
            }
          }, {
            key: "cell(totalAmount)",
            fn: function(innerRow) {
              return [_c('span', {
                staticClass: "font-weight-bold"
              }, [_vm._v("₹ " + _vm._s(Number(String(innerRow.value).replace(/,/g, '')).toLocaleString('en-IN')))])]
            }
          }])
        })], 1)]
      }
    }, {
      key: "cell(actions)",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "btn-action shadow-sm mr-2",
          attrs: {
            "size": "sm",
            "variant": "light"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.toggleDetails(scope ? scope.item : null)
            }
          }
        }, [_c('md-icon', {
          staticClass: "text-primary",
          attrs: {
            "size": "18"
          }
        }, [_vm._v(_vm._s(scope && scope.item && scope.item._showDetails ? 'visibility_off' : 'visibility'))])], 1), _vm._v(" "), _c('b-button', {
          staticClass: "btn-action shadow-sm",
          attrs: {
            "size": "sm",
            "variant": "light"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('show-service-detail', scope ? scope.item : null)
            }
          }
        }, [_c('md-icon', {
          staticClass: "text-secondary",
          attrs: {
            "size": "18"
          }
        }, [_vm._v("open_in_new")])], 1)], 1)]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center text-primary my-5"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  }), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v("Loading history...")])], 1)])], 2)], 1), _vm._v(" "), ((!_vm.items || _vm.items.length === 0) && !_vm.loading) ? _c('div', {
    staticClass: "text-center p-5"
  }, [_c('md-icon', {
    staticClass: "text-muted mb-3",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted"
  }, [_vm._v("No maintenance records found for this period.")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5541957b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/MaintenanceHealthTab.vue
// module id = 2640
// module chunks = 0